export default '/static/frontend/ReachDigital/12gobiking/dist/assets/virement-bancaire-1120bcba.png'